/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
*/

import {
    FETCH_SWAGGER_REQUEST, FETCH_SWAGGER_SUCCESS,
    FETCH_SWAGGER_FAILURE, SwaggerAction
} from '../types/swagger';

const initialState = {
    loading: true,
    swagger: {},
    error: ''
}

const swaggerReducer = (state = initialState, action: SwaggerAction) => {
    switch (action.type) {
        case FETCH_SWAGGER_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case FETCH_SWAGGER_SUCCESS:
            return {
                ...state,
                loading: false,
                swagger: action.payload
            }
        case FETCH_SWAGGER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        default:
            return state
    }
}

export default swaggerReducer;
